import { Controller } from "@hotwired/stimulus";

/** Checkbox Controller to simulate radio boxes.
 * 
 * The controller will ensure that only a maximum of one Checkbox
 * within its scope is enabled at any point in time.
 * The difference to normal radio buttons is, that there can also be none
 * checked and the checkboxes are normally mapped to different model attributes
 * vs. radioboxes which do relate to one model attributes value.
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('change', (event) => {
      if (event.target.tagName !== 'INPUT' || event.target.type !== 'checkbox') {
        return;
      }

      const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => {
        if (checkbox !== event.target && checkbox.checked) {
          checkbox.checked = false;
          const src_event = new Event('change');
          checkbox.dispatchEvent(src_event);
        }
      });
    });
  }
}
